/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Guest } from '../../models/guest';

export interface GuestsControllerUploadPhoto$Params {
  id: string;
      body: {
'file'?: Blob;
}
}

export function guestsControllerUploadPhoto(http: HttpClient, rootUrl: string, params: GuestsControllerUploadPhoto$Params, context?: HttpContext): Observable<StrictHttpResponse<Guest>> {
  const rb = new RequestBuilder(rootUrl, guestsControllerUploadPhoto.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Guest>;
    })
  );
}

guestsControllerUploadPhoto.PATH = '/admin/guests/{id}/photo';
